import React from 'react'
import styled from 'styled-components'

export default FilterGroupLayout
function FilterGroupLayout({ children }) {
  return (
    <Wrapper>
      <Content>{children}</Content>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  padding-left: 32px;
  padding-right: 32px;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e5e5;
`

const Content = styled.div`
  padding-bottom: 10px;
  padding-top: 10px;
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/shared/components/FilterGroup/layout.js